import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import AboutUs from './pages/AboutUs';
import Products from './pages/Products';
import ContactUs from './pages/ContactUs';
import Brands from './pages/Brands';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path='/' element={<HomePage />} />
        <Route exact path='/aboutus' element={<AboutUs />} />
        <Route exact path='/products' element={<Products />} />
        <Route exact path='/brands' element={<Brands />} />
        <Route exact path='/contactus' element={<ContactUs />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
